module.exports = __webpack_public_path__ + "assets/img/healthcareSolutions-radiology.846844ea.png";